
import Imgslider from './components/imgslider';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        {/* start importing the content from here */}
        <Imgslider />
      </header>
    </div>
  );
}

export default App;
